import axios from 'axios';

// ----------------------------------------------------------------------

const findPassword = async (requestId: string, identification: string, email: string, verificationCode: string) => {
  return await axios.post('/api/auth/find-password', {requestId, identification, email, verificationCode})
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default findPassword;